import { createFileRoute } from "@tanstack/react-router";

import { env } from "@/env/public-env";
import { StructuredData } from "@/shared/components/structured-data";
import { NewsroomFeatures } from "@/shared/newsroom-features";
import {
  seo,
  getCanonicalLinks,
  createPageTitle,
} from "@/utils/seo";
import { WebLayout } from "@/web/layout/web-layout";

const NEWSROOM_TITLE_PARTS = ["Newsroom"];

export const Route = createFileRoute("/_web/newsroom/")({
  component: NewsroomPage,
  head: () => ({
    meta: [
      ...seo({
        title: createPageTitle("Newsroom"),
        description:
          "Latest news, press releases, and announcements from speech-agent - the platform for seamless AI integration with real-time data.",
        keywords: "speech-agent",
        canonical: "https://speech-agent.cz/newsroom",
        image: `${env.VITE_BASE_URL}/api/og/page/newsroom.png`,
      }),
    ],
    links: [
      ...getCanonicalLinks(`${env.VITE_BASE_URL}/newsroom`),
    ],
  }),
});

function NewsroomPage() {
  return (
    <WebLayout>
      <StructuredData
        url="https://speech-agent.cz/newsroom"
        description="Latest news, press releases, and announcements from speech-agent - the platform for seamless AI integration with real-time data."
        about="Company News and Updates"
        titleParts={NEWSROOM_TITLE_PARTS}
      />
      <NewsroomFeatures />
    </WebLayout>
  );
}
